import { CloseIcon } from "./Icons";

interface KeyboardHelpProps {
  onClose: () => void;
}

const SHORTCUTS: Array<[string, string]> = [
  ["← / →", "Previous and next move"],
  ["↑ / ↓", "Jump two moves"],
  ["Home / End", "Start and end of the game"],
  ["F", "Flip the board"],
  ["C", "Copy the PGN"],
];

export function KeyboardHelp({ onClose }: KeyboardHelpProps) {
  return (
    <>
      <div className="sheet-backdrop" onClick={onClose} />
      <div className="sheet" role="dialog" aria-modal="true" aria-label="Keyboard shortcuts">
        <div className="sheet__grip" />
        <div className="sheet__row">
          <h2 className="sheet__title">Keyboard shortcuts</h2>
          <button className="iconbtn" onClick={onClose} aria-label="Close shortcuts">
            <CloseIcon />
          </button>
        </div>
        <dl className="shortcuts">
          {SHORTCUTS.map(([keys, description]) => (
            <div className="shortcuts__row" key={keys}>
              <dt>
                <kbd>{keys}</kbd>
              </dt>
              <dd>{description}</dd>
            </div>
          ))}
        </dl>
        <p className="planned__desc">
          Shortcuts work while the analysis board is open. They stay out of the way while you type.
        </p>
      </div>
    </>
  );
}
